"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ToolTipStyled = exports.ToolTipLightStyled = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Wrapper = exports.Wrapper = _styledComponents["default"].li(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  :first-of-type {\n    margin-left: 0;\n  }\n\n  :last-of-type {\n    margin-right: 0;\n  }\n\n  padding: 0;\n  width: 96px;\n  height: 54px;\n  margin-top: 0;\n  display: flex;\n  color: #dcdfec;\n  margin-left: 5px;\n  margin-right: 5px;\n  text-align: center;\n  position: relative;\n  list-style-type: none;\n  box-sizing: border-box;\n  flex-direction: column;\n  justify-content: center;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: rgb(247, 248, 249);\n\n  opacity: ", ";\n\n  background-image: url(", ");\n\n  :hover {\n    background-image: url(", ");\n  }\n\n  :active {\n    background-image: url(", ");\n  }\n\n  :focus {\n    background-image: url(", ");\n  }\n\n  cursor: ", ";\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  return props.available ? '1' : '0.5';
}, function (props) {
  return props.styles["default"].thumbnail;
}, function (props) {
  return props.styles.hover.thumbnail;
}, function (props) {
  return props.styles.active.thumbnail;
}, function (props) {
  return props.styles.focus.thumbnail;
}, function (props) {
  return props.available ? 'pointer' : 'not-allowed';
}, function (props) {
  return props.selected && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n      background-image: url(", ");\n    "])), function (props) {
    return props.styles.active.thumbnail;
  });
}, function (props) {
  return !props.available && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n      background-image: url(", ");\n    "])), function (props) {
    return props.styles.disabled.thumbnail;
  });
});
var ToolTipStyled = exports.ToolTipStyled = {
  color: '#000',
  backgroundColor: '#fff'
};
var ToolTipLightStyled = exports.ToolTipLightStyled = {
  color: '#fff',
  backgroundColor: '#000'
};